export default {
  host: process.env.NODE_ENV === 'development' ? 'http://192.168.1.9:10000' : '',
  upload_url: (process.env.NODE_ENV === 'development' ? 'http://192.168.1.9:10000' : '') + '/api/common/upload',
  platform_arr: ['通用', 'IOS', '安卓']
}